var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.1 33.51a11.78 11.78 0 0 0 -16.2 0l-9.77 9.24c-5.6 5.09-1.56 14.82 6 14.44 4.1-.11 7.43-2.21 11.86-2.13 4.59-.08 8 1.77 12.12 2.13 7.43.17 11.27-9.45 5.75-14.44zm9.9 17.67a6.3 6.3 0 0 1 -6.1 4c-3.85-.56-7.24-2.18-11.9-2.12s-8 2-12.12 2.13a6.35 6.35 0 0 1 -4.37-11l9.76-9.19a9.8 9.8 0 0 1 13.46 0l9.76 9.24a6.28 6.28 0 0 1 1.51 6.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.92 19.93c-3.82-.75-6.74 3.5-7.5 7.16-2.28 11.33 8.7 13.49 11.27 2.5 1.05-4.71-.61-8.96-3.77-9.66zm1.82 9.23c-2.14 8.5-9 7-7.37-1.63 1.74-7.73 8.94-7.83 7.37 1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.73 26.05c3.8 0 6.89-4.32 6.89-9.62-.38-12.76-13.4-12.76-13.77 0 0 5.3 3.09 9.62 6.88 9.62zm0-17.24c6.45.44 6.45 14.8 0 15.24-6.45-.44-6.44-14.8 0-15.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.58 27.09c-.75-3.66-3.68-7.91-7.5-7.16-7.08 1.79-4.08 16.88 2.84 16.92 3.92-.13 5.73-4.68 4.66-9.76zm-4.2 7.71c-4.93.74-7.65-11.51-2.87-12.91 2.88-.28 4.5 3.11 5.12 5.64.78 3.47-.25 6.83-2.25 7.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.27 26.05c3.79 0 6.88-4.32 6.88-9.62-.37-12.76-13.39-12.76-13.77 0 0 5.3 3.09 9.62 6.89 9.62zm0-17.24c6.45.44 6.44 14.8 0 15.24-6.45-.44-6.45-14.8 0-15.24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotas);
export default __webpack_public_path__ + "static/media/mascotas.a004c612bb063b6abc24d769a267dadb.svg";
export { ForwardRef as ReactComponent };